<h2 mat-dialog-title>Inactive share</h2>
<div mat-dialog-content class="mat-body-1">
  <p>Changing the price will <b>activate</b> this share.</p>
</div>
<mat-dialog-actions>
  <button mat-button [matDialogClose]="false">Abort</button>
  <button mat-button [matDialogClose]="true">Proceed</button>
</mat-dialog-actions>
